import { Link } from 'react-router-dom';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import AuthoritySection from './components/AuthoritySection';
import WhySection from './components/WhySection';
import ProblemSection from './components/ProblemSection';
import SolutionSection from './components/SolutionSection';
import AngleDesignSection from './components/AngleDesignSection';
import MaterialSection from './components/MaterialSection';
import QualityCommitmentSection from './components/QualityCommitmentSection';
import ProductLineupSection from './components/ProductLineupSection';
import UseCaseSection from './components/UseCaseSection';
import ScenesSection from './components/ScenesSection';
import NineAnglesSection from './components/NineAnglesSection';
import BusinessSection from './components/BusinessSection';
import ComparisonSection from './components/ComparisonSection';
import MessageSection from './components/MessageSection';
import FAQSection from './components/FAQSection';
import ScheduleSection from './components/ScheduleSection';
import ReturnsSection from './components/ReturnsSection';
import RiskSection from './components/RiskSection';
import ExecutorSection from './components/ExecutorSection';
import CTASection from './components/CTASection';
import Footer from './components/Footer';
import FloatingCTA from '../../components/feature/FloatingCTA';
import ScrollToTop from '../../components/feature/ScrollToTop';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      {/* ナビゲーション */}
      <Navbar />

      {/* セクション */}
      <Hero />
      <NineAnglesSection />
      <AngleDesignSection />
      <AuthoritySection />
      <WhySection />
      <ProblemSection />
      <SolutionSection />
      <MaterialSection />
      <QualityCommitmentSection />
      <ProductLineupSection />
      <UseCaseSection />
      <ScenesSection />
      <BusinessSection />
      <ComparisonSection />
      <MessageSection />
      <FAQSection />
      <ScheduleSection />
      <ReturnsSection />
      <RiskSection />
      <ExecutorSection />
      <CTASection />
      <Footer />
      <FloatingCTA />
      <ScrollToTop />
    </div>
  );
}
